import { createCompoundComponent } from '../../utilities'

import { Item } from './Item'
import { Listbox as BaseListbox } from './Listbox'

export const Listbox = createCompoundComponent(BaseListbox, { Item })
